"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = exports.ContentsRoot = void 0;

var tslib_1 = require("tslib");

var ui_box_1 = require("@hopin-team/ui-box");

var polished_1 = require("polished");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

exports.ContentsRoot = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  position: relative;\n  max-height: 100vh;\n  grid-area: modal;\n  ", "\n"], ["\n  position: relative;\n  max-height: 100vh;\n  grid-area: modal;\n  ", "\n"])), function (_a) {
  var shadow = _a.shadow;
  return shadow && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      box-shadow: 0 0 ", " rgba(0, 0, 0, 0.08);\n    "], ["\n      box-shadow: 0 0 ", " rgba(0, 0, 0, 0.08);\n    "])), (0, polished_1.rem)(24));
});
exports.Container = (0, styled_components_1.default)(ui_box_1.Box)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  height: 100%;\n"], ["\n  height: 100%;\n"])));
var templateObject_1, templateObject_2, templateObject_3;